import React, { useImperativeHandle, useState, forwardRef } from 'react'
import Button from '@material-ui/core/Button'


function Success(props, ref) {
    const [state, setState] = useState({
        modal: false,
        overlay: false
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        setState(prev => ({
            ...prev,
            overlay: true
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true
            }))
        }, 100)
    }

    const handleClose = () => {
        setState(prev => ({
            ...prev,
            modal: false
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false
            }))
        }, 50)
    }

    const handleOk = () => {
        props.acceptCallback && props.acceptCallback(false)
    }
    return (
        <div id="overlay" className={props.blur || state.overlay ? 'visible' : ''}>
            <div className={`box success ${props.popup || state.modal ? 'show' : ''}`}>
                <h3>
                    {props.mainMessage}
                </h3>
                <p>
                    {props.secondaryMessage}
                </p>
                <div className="buttons">
                    <Button className="accept-request" onClick={handleOk}>
                        ОК
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(Success)